import { Link } from 'wouter-preact'

import { Typography, AngleBracketsIcon, RightArrowIcon } from 'components'

const DappsSection = () => (
	<div class='flex-1 border-t border-solid border-t-black-800 p-5'>
		<Link
			class='group flex cursor-pointer items-center justify-between rounded px-2.5 py-2.5 text-black-200 hover:bg-black-800 hover:text-black-100'
			href='/dapps'
		>
			<div class='flex items-center'>
				<AngleBracketsIcon />
				<Typography
					class='ml-3'
					color='text-black-200 group-hover:text-black-100'
					text='All dApps'
					variant='text2'
				/>
			</div>
			<RightArrowIcon />
		</Link>
	</div>
)

export { DappsSection }
